<nb-form-field>
    <input
        fieldSize="small"
        class="search-input"
        placeholder="Поиск"
        nbInput
        fullWidth
        [formControl]="inputFormControl"
        (mousedown)="togglePanel()"
        scrollStrategy="noop"
        #autoCompleteInput
    >
    <button (click)="searchByKeyword()" nbSuffix nbButton size="small" style="background: none">
        <nb-icon icon="search-outline"></nb-icon>
    </button>
</nb-form-field>

<ng-container *ngIf="!(hiddenPanelObservable$ | async) && (terms$ | async) as terms">
    <div class="custom-autocomplete">
        <div class="custom-autocomplete__item" *ngFor="let term of terms">
            <div class="auto-item" (click)="viewProduct(term)">
                <div class="auto-item__title">
                    <span class="title cursor-pointer">{{ term.header }} ({{ term.countVersion }})</span>
                </div>
            </div>
        </div>
    </div>
</ng-container>

